<template>
	<div class="card-footer" style="padding: 1rem !important">
		<div class="media">
			<div class="media-body">
		    	<textarea 
		    		id="texto"
		    		class="form-control" 
		    		maxlength="750" 
		    		placeholder="Escriba el mensaje aquí" 
		    		aria-label="Escriba el mensaje aquí" 
		    		aria-describedby="message" 
		    		v-model="newMessage" 
		    		@keyup.enter="sendMessage()"
		    		@keydown="isTyping()"
		    		noCounter
		    		rows="1" 
		    		ref="message" 
		    		spellcheck="false"></textarea>
		  	</div>
			<div class="align-self-end ml-3" v-if="newMessage">
				<button class="btn btn-primary" type="button" v-on:click="sendMessage()">
					<i class="material-icons">send</i>
				</button>
			</div>
		</div>
		<span class="text-danger" v-if="errorMessage">
			{{errorMessage}}
		</span>
	</div>
</template>
<script>
	export default {
		data() {
            return {
                newMessage: '',
                errorMessage: ''
            }
        },

        mounted(){
        	this.init()
        },

        methods: {
        	init: function(){
				this.$refs.message.addEventListener('keyup', function() {
					var lines = this.value.substr(0, this.value.length).split("\n").length || 0
					if (lines> 5) {
						this.style.overflow = 'auto';
					}else{
						this.style.height = 0;
						this.style.height = this.scrollHeight + 'px';
						this.style.overflow = 'hidden';
					}
				}, false);
			},

			isTyping(){
				this.$emit('isTyping', true);
			},

            sendMessage() {
                this.$emit('message', this.newMessage);

                this.newMessage = ''
            },
        },

        watch: {
			newMessage: function(val){
				if (this.errorMessage) {
					this.errorMessage = ''
				}
				
				if (val.length>=750) {
					this.errorMessage = 'Ha superado el límite de carácteres.'
				}
			}
		},
	}
</script>